import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import styles from '../AnnouncementsV2.module.css';

const EmptyState = () => {
  return (
    <div className={styles.emptyState}>
      <FiMessageSquare size={48} className={styles.emptyStateIcon} />
      <p className={styles.emptyStateText}>No announcements yet</p>
      <p className={styles.emptyStateSubtext}>
        Create your first announcement to share important updates with your students
      </p>
    </div>
  );
};

export default EmptyState;
